import { supabase } from "@/lib/supabase/supabaseClient";
import { EditQuestionBankQuestionProps } from ".";

export const editQuestionBankQuestion = async (data: EditQuestionBankQuestionProps) => {
    const editedQuestionData = await supabase
        .from('question_bank')
        .select('*')
        .eq('id', data.id)
        .maybeSingle()
        .throwOnError()
        .then(res => res.data);

    if (!editedQuestionData) {
        throw new Error("Question bank question not found");
    }

    if (editedQuestionData.crm_system !== data.crm_system && data.crm_system) {
        const field_type_context_stack = [
            ...editedQuestionData.field_type_context_stack,
            {
                crm_system: data.crm_system,
                field_type: data.field_type!
            }
        ];
        return await supabase
            .from('question_bank')
            .update({
                ...data,
                field_type_context_stack
            })
            .eq('id', data.id)
            .select()
            .maybeSingle()
            .throwOnError()
            .then(res => res.data);
    } else {
        return await supabase
            .from('question_bank')
            .update(data)
            .eq('id', data.id)
            .select()
            .maybeSingle()
            .throwOnError()
            .then(res => res.data);
    }
}